import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Form from "rc-field-form";
import Field from "../../../../components/Field";
import Switch from "../../../../components/Inputs/Switch";
import { mergeTaskListConfigWithDefaults } from "../../../Home/Manager/TaskList/config";
// import { useConfigurationModule } from "../hooks/useConfigurationModule";

export const TASK_LIST_FORM_ID = "dashboard-task-list-form";

const sections = [
	{
		key: "timesheetsNeedingApproval",
		title: "timesheets-that-need-approval",
		items: [
			{ key: "team", label: "team" },
			{ key: "weekly", label: "weekly" },
		],
	},
	{
		key: "missedPunches",
		title: "missed-punches",
		items: [
			{ key: "summary", label: "missed-punches" },
		],
	},
	{
		key: "requestsToReview",
		title: "requests-to-review",
		items: [
			{ key: "schedule", label: "schedule-request" },
			{ key: "pto", label: "pto-request" },
			{ key: "clock", label: "clock-request" },
			{ key: "availability", label: "availability-request" },
			{ key: "timesheet", label: "timesheet-request" },
		],
	},
	{
		key: "overtime",
		title: "timesheets-with-overtime",
		items: [
			{ key: "summary", label: "timesheets-with-overtime" },
		],
	},
	{
		key: "mealViolations",
		title: "meal-violations",
		items: [
			{ key: "team", label: "team" },
		],
	},
	{
		key: "clockExceptions",
		title: "clock-exceptions",
		items: [
			{ key: "total", label: "total-exceptions" },
			{ key: "cameEarly", label: "came-early" },
			{ key: "cameLate", label: "came-late" },
			{ key: "leftEarly", label: "left-early" },
			{ key: "leftLate", label: "left-late" },
			{ key: "notClocked", label: "not-clocked" },
			{ key: "notScheduled", label: "not-scheduled" },
			{ key: "longBreak", label: "long-break" },
			{ key: "shortBreak", label: "short-break" },
		],
	},
];

function TaskList({ onSave }) {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	// const config = useConfigurationModule("dashboard.taskList");
	const config = undefined // TODO: remove this, temporary fix

	useEffect(() => {
		form.setFieldsValue(mergeTaskListConfigWithDefaults(config));
	}, [config, form]);

	const onFinish = useCallback(async (values) => {
		try {
			await onSave(mergeTaskListConfigWithDefaults(values));
			toast.success(t("preferences-saved-successfully"));
		} catch {
			toast.error(t("error-saving-preferences"));
		}
	}, [onSave, t]);

	return (
		<Form id={TASK_LIST_FORM_ID} form={form} onFinish={onFinish}>
			<div className="row px-4 pt-3">
				{sections.map(({ key: section, title, items }) => (
					<div className="col-lg-6 mb-3" key={section}>
						<h5>{t(title, { defaultValue: title })}</h5>
						{items.map(({ key, label }) => (
							<Field key={key} name={[section, key]} valuePropName="checked" className="mb-2">
								<Switch>{t(label)}</Switch>
							</Field>
						))}
					</div>
				))}
			</div>
		</Form>
	);
}

export default TaskList;
